import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    theme: {
        themes: {
            light: {
                primary:    "#F06292",
                secondary:  "#ff6400",
                accent:     "#ff5722",
                error:      "#f44336",
                warning:    "#ff9800",
                info:       "#2196f3",
                success:    "#4caf50",
                selected :  "#C8E6C9"
            },
            dark: {
                primary:    '#C2185B',
                secondary:  "#c43100",
                accent:     "#F4511E",
                error:      "#B71C1C",
                warning:    "#E65100",
                info:       "#0D47A1",
                success:    "#1B5E20",
                selected :  "#1B5E20"
            },
        },
    },
}

export default new Vuetify(opts)